import AgoraRTM from "agora-rtm-sdk";
import _ from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { AGORA_APP_ID, WS_URL } from "../../config";
import { screens } from "../../constants";
import useAppAccessor from "../../hooks/useappAccessor";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppNavigation from "../../hooks/useAppNavigation";
import { getItemDetailServiceForPartnerCo } from "../../services/partnerco.service";
import { getItemDetailService } from "../../services/shopcom.service";
import { getItemDetailServiceTranont } from "../../services/tranont.service";
import {
  copresenterInfo,
  setPinnedLayoutUid,
  setCopresenterInfo,
  setCopresenterUids,
  setMutedByHost,
  showAttendeeCountFunc,
  toastMess,
  turnOffHostCamera,
  turnOffHostMic,
  turnOffMic,
  turnOnHostCamera,
  turnOnHostMic
} from "../agora-live/components/streamControls/controls.actions";
import {
  getProductDetails,
  setActivityInteractionData,
  setInteractionData,
  setProductDetailsLoading,
} from "../interactions/interaction.actions";
import {
  setAllAttendeeList, setAttendeeList, setHostConnectionStatus, setHostTime,
  setPersonNum, setStramState
} from "../live-main/livemain.actions";
import ActivityChat from "./components/activity-chat";
import AttendeesChat from "./components/attendees-chat";
import Chatbox from "./components/box-chat";
import HeaderChat from "./components/header-chat";
import MessageItem from "./components/messenger-chat";

const APP_ID = AGORA_APP_ID;
const rtmConfig = {
  logFilter: {
    error: true,
  },
} as any;
export const rtmClient = AgoraRTM.createInstance(APP_ID, rtmConfig);
let client = rtmClient;
const isHost = () => {
  return window.location.href.indexOf("/stream") > -1;
};

let ws: WebSocket | null = null;
let heartbeatInterval: NodeJS.Timeout | null = null;

type UpdateTask = {
  key: string;
  updater: (currentValue: any) => Promise<string> | string;
  resolve: (value: any) => void;
  reject: (error: any) => void;
};

const attributeUpdateQueues = new Map<string, UpdateTask[]>();
const attributeUpdateLocks = new Map<string, boolean>();
const PINNED_PRESENTER_UID_KEY = "pinned_presenter_uid";

const AgoraChat = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { navigate } = useAppNavigation();
  const { getUserData, getInteractions, getLiveMainData, getControls } =
    useAppAccessor();

  const { rtmTokenData, createStreamData, joinData, joinWithAttendeeData, hostTime, isHostConnected, streamState, allAttendeeList } =
    getLiveMainData();
  const { isCameraOn, isMicOn, isScreenSharing, copresenterMuteUid, rotateDegree, showAttendeeCount, uid, roleCopresenter, pinnedLayoutUid } = getControls();
  const { user } = getUserData();
  const { interactionData, selectedInteraction } =
    getInteractions();
  const isInteractionAdded = useRef(false);

  const [activeTab, setActiveTab] = useState("chat");
  const [messages, setMessages] = useState<any>([]);
  const [hisotryMSG, setHistoryMSG] = useState<boolean>(false);
  const [text, setText] = useState("");
  const [attendeeNum, setAttendeeNum] = useState(0);
  const [channel, setChannel] = useState<any>(null);
  const { publicUserData } = user;
  const [userConnect, setUserConnect] = useState({});
  const [memberJoin, setMemberJoin] = useState(null);
  const [memberLeft, setMemberLeft] = useState(null);
  const [isChatOn, setIsChatOn] = useState(false);
  const [interactionDataArray, setInteractionDataArray] = useState<any>([]);
  const [loged, setLoged] = useState(false);
  const [joinedUser, setJoinedUser] = useState<any>({});
  const [leftUser, setLeftUser] = useState<any>({});
  const [joinedUserArray, setJoinedUserArray] = useState<any>([]);
  const lastBroadcastPinnedLayoutUid = useRef<number | null | undefined>(undefined);
  const pinnedLayoutUidHydrated = useRef(false);

  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
  let currentProduct: any = [];
  const { language } = getUserData();

  const appendMessage = (message: {
    text: string;
    uid: string;
    createAt: string;
    type?: string;
    firstName?: string;
    lastName?: string;
  }) => {
    if (message.type == "TEXT") {
      setMessages((messages: any) => [...messages, message]);
    }
  };

  //**************************ATTENDEE LIST********************************
  //Receiving attendee list from channel and then updating the attendee list in the store
  const updateAttendeeList = useCallback(async () => {
    var _attendees = await channel?.getMembers();
    var _attendeeList = [];
    var _allAttendeeList = JSON.parse(JSON.stringify(allAttendeeList));

    for (var i = 0; _attendees && i < _attendees.length; i++) {
      var userAttribute = await client?.getUserAttributes(_attendees[i]);
      _attendeeList.push(userAttribute);
      if (
        _allAttendeeList.findIndex(
          (item: any) => item.uid == userAttribute.uid
        ) == -1
      ) {
        _allAttendeeList.push(userAttribute);
      }
    }
    if (_allAttendeeList.length > allAttendeeList.length) {
      dispatch(setAttendeeList(_attendeeList));
      dispatch(setAllAttendeeList(_allAttendeeList));
    }
  }, [channel, allAttendeeList, dispatch]);

  //Calling to update atendee list
  useEffect(() => {
      updateAttendeeList();
      let interval = setInterval(() => {
        updateAttendeeList();
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }, [channel?.channelId, allAttendeeList.length]);

  //**********************************************************

  const processAttributeUpdateQueue = async (key: string) => {
    if (attributeUpdateLocks.get(key)) {
      return;
    }

    const queue = attributeUpdateQueues.get(key);
    if (!queue || queue.length === 0) {
      return;
    }

    attributeUpdateLocks.set(key, true);

    try {
      while (queue.length > 0) {
        const task = queue.shift();
        if (!task) continue;

        try {
          const currentAttributes = await client?.getChannelAttributes(channel?.channelId);
          const currentValue = currentAttributes?.[key]?.value;
          
          const newValue = await task.updater(currentValue);
          
          const logData: any = {
            key: key,
            channelId: channel?.channelId,
            rawValue: newValue,
            timestamp: new Date().toLocaleTimeString(),
          };

          try {
            const parsedValue = JSON.parse(newValue);
            logData.parsedValue = parsedValue;

            if (key === 'host_copresenter_info' && Array.isArray(parsedValue)) {
              console.table(parsedValue.map((item: any, index: number) => ({
                index: index,
                uid: item.uid,
                name: `${item.firstName || ''} ${item.lastName || ''}`.trim() || 'N/A',
                videoOff: item.videoOff ? '❌ OFF' : '✅ ON',
                micOff: item.micOff ? '❌ OFF' : '✅ ON',
                isScreenSharing: item.isScreenSharing ? '✅ YES' : '❌ NO',
                rotateDegree: item.rotateDegree ?? 0,
              })));
            } else {
              console.table(logData);
            }
          } catch (e) {
            logData.parseError = 'Not JSON';
            console.table(logData);
          }

          const result = await client?.addOrUpdateChannelAttributes(
            channel?.channelId,
            { [key]: newValue },
            { enableNotificationToChannelMembers: true }
          );

          task.resolve(result);
        } catch (error) {
          task.reject(error);
        }
      }
    } finally {
      attributeUpdateLocks.set(key, false);
      
      if (queue && queue.length > 0) {
        setTimeout(() => processAttributeUpdateQueue(key), 0);
      }
    }
  };

  const addOrUpdateChannelAttributes = async (
    key: string,
    valueOrUpdater: string | ((currentValue: any) => Promise<string> | string)
  ): Promise<any> => {
    if (!channel) {
      return;
    }

    return new Promise((resolve, reject) => {
      const updater = typeof valueOrUpdater === 'string'
        ? () => Promise.resolve(valueOrUpdater)
        : valueOrUpdater;

      if (!attributeUpdateQueues.has(key)) {
        attributeUpdateQueues.set(key, []);
      }

      const queue = attributeUpdateQueues.get(key)!;
      queue.push({ key, updater, resolve, reject });

      processAttributeUpdateQueue(key);
    });
  };

  const updateCopresenterInfo = async (
    updater: (currentInfo: any[]) => any[]
  ): Promise<void> => {
    await addOrUpdateChannelAttributes('host_copresenter_info', async (currentValue) => {
      let currentInfo: any[] = [];
      
      if (currentValue) {
        try {
          currentInfo = JSON.parse(currentValue);
        } catch (e) {
          currentInfo = [];
        }
      }
      
      const updatedInfo = updater(currentInfo);
      return JSON.stringify(updatedInfo);
    });
  };

  const updateCopresenterUids = async (
    updater: (currentUids: number[]) => number[]
  ): Promise<void> => {
    await addOrUpdateChannelAttributes('host_copresenter_uids', async (currentValue) => {
      let currentUids: number[] = [];
      
      if (currentValue) {
        try {
          currentUids = JSON.parse(currentValue);
        } catch (e) {
          currentUids = [];
        }
      }
      
      const updatedUids = updater(currentUids);
      return JSON.stringify(updatedUids);
    });
  };

  const parsePinnedLayoutUid = (rawValue: any): number | null => {
    if (rawValue === undefined || rawValue === null || rawValue === "" || rawValue === "null") {
      return null;
    }
    const parsedValue = Number(rawValue);
    return Number.isNaN(parsedValue) ? null : parsedValue;
  };

  //************************ACTION STATE (CAMERA, MIC, SHARING SCREEN,...)**********************************
  useEffect(() => {
    if (isHost()) {
      broadcastHostState(!isCameraOn, "HOST_TURNOFF_CAM");
    }
    if (channel && channel.channelId) {
      updateCopresenterInfo((currentInfo) => {
        const updatedInfo = [...currentInfo];
        for (let i = 0; i < updatedInfo.length; i++) {
          if (updatedInfo[i].uid == uid) {
            updatedInfo[i] = { ...updatedInfo[i], videoOff: !isCameraOn };
            break;
          }
        }
        dispatch(setCopresenterInfo(updatedInfo));
        return updatedInfo;
      }).catch((err) => {
        console.error('Error updating copresenter info (camera):', err);
      });
    }
  }, [isCameraOn]);

  useEffect(() => {
    if (isHost()) {
      broadcastHostState(!isMicOn, "HOST_TURNOFF_MIC");
    }
    if (channel && channel.channelId) {
      updateCopresenterInfo((currentInfo) => {
        const updatedInfo = [...currentInfo];
        for (let i = 0; i < updatedInfo.length; i++) {
          if (updatedInfo[i].uid == uid) {
            updatedInfo[i] = { ...updatedInfo[i], micOff: !isMicOn };
            break;
          }
        }
        dispatch(setCopresenterInfo(updatedInfo));
        return updatedInfo;
      }).catch((err) => {
        console.error('Error updating copresenter info (mic):', err);
      });
    }
  }, [isMicOn]);

  useEffect(() => {
    if (channel && channel.channelId) {
      updateCopresenterInfo((currentInfo) => {
        const updatedInfo = [...currentInfo];
        let found = false;
        for (let i = 0; i < updatedInfo.length; i++) {
          if (updatedInfo[i].uid == uid) {
            updatedInfo[i] = { ...updatedInfo[i], isScreenSharing: isScreenSharing };
            found = true;
            break;
          }
        }
        if (!found) {
          updatedInfo.push({
            uid: uid,
            micOff: !isMicOn,
            videoOff: !isCameraOn,
            isScreenSharing: isScreenSharing,
            firstName: publicUserData?.family_name,
            lastName: publicUserData?.given_name,
            rotateDegree: rotateDegree,
          });
        }
        dispatch(setCopresenterInfo(updatedInfo));
        return updatedInfo;
      }).catch((err) => {
        console.error('Error updating copresenter info (screen sharing):', err);
      });
    }
  }, [isScreenSharing]);

  useEffect(() => {
    if (channel && channel.channelId) {
      updateCopresenterInfo((currentInfo) => {
        const updatedInfo = [...currentInfo];
        for (let i = 0; i < updatedInfo.length; i++) {
          if (updatedInfo[i].uid == uid) {
            updatedInfo[i] = { ...updatedInfo[i], rotateDegree: rotateDegree };
            break;
          }
        }
        dispatch(setCopresenterInfo(updatedInfo));
        return updatedInfo;
      }).catch((err) => {
        console.error('Error updating copresenter info (rotate):', err);
      });
    }
  }, [rotateDegree]);

  useEffect(() => {
    if (isHost()) {
      addOrUpdateChannelAttributes(
        "SHOW_ATTENDEE",
        showAttendeeCount == true ? "true" : "false"
      );
    }
  }, [showAttendeeCount]);

  useEffect(() => {
    if (isHost()) {
      broadcastMuteCopresenter(copresenterMuteUid, "MUTE_COPRESENTER");
    }
  }, [copresenterMuteUid]);


  //************************RTM MESSAGE**********************************
  //************************RECIEVING CHANLE MESSAGE**********************************
  const connect = async (rtmTokenData: any, stream_instance_id: string) => {
    if (rtmTokenData.user_id && rtmTokenData.token && stream_instance_id) {
      setLoged(true);
      await client.login({
        uid: rtmTokenData.user_id,
        token: rtmTokenData.token,
      });
      await client.setLocalUserAttributes({
        firstName:
          publicUserData?.given_name && publicUserData?.given_name.length > 0
            ? publicUserData?.given_name
            : "Anonymous",
        lastName:
          publicUserData?.family_name && publicUserData?.family_name.length > 0
            ? publicUserData?.family_name
            : "User",
        avatar:
          publicUserData?.picture && publicUserData?.picture.length > 0
            ? publicUserData?.picture
            : "https://s3-us-west-2.amazonaws.com/investo-bucket/default_avatar.png",
        id:
          publicUserData?.userId && publicUserData?.userId.length > 0
            ? publicUserData?.userId
            : joinData.attendee_id,
        uid: rtmTokenData?.user_id,
        email:
          publicUserData?.email && publicUserData?.email.length > 0
            ? publicUserData?.email
            : "",
      });
      const channel = await client.createChannel(stream_instance_id);
      await channel.join();

      client.getChannelAttributes(channel.channelId).then((data: any) => {
        if (data.hasOwnProperty("SHOW_ATTENDEE")) {
          dispatch(
            showAttendeeCountFunc(
              data.SHOW_ATTENDEE.value == "true" ? true : false
            )
          );
        }
        if (data.hasOwnProperty("host_copresenter_uids")) {
          dispatch(
            setCopresenterUids(JSON.parse(data.host_copresenter_uids.value))
          );
        }
        if (data.hasOwnProperty("host_copresenter_info")) {
          dispatch(
            setCopresenterInfo(JSON.parse(data.host_copresenter_info.value))
          );
        }
        if (data.hasOwnProperty(PINNED_PRESENTER_UID_KEY)) {
          const parsedPinnedUid = parsePinnedLayoutUid(data[PINNED_PRESENTER_UID_KEY].value);
          dispatch(setPinnedLayoutUid(parsedPinnedUid));
          lastBroadcastPinnedLayoutUid.current = parsedPinnedUid;
        }
        pinnedLayoutUidHydrated.current = true;
        // Monitor host connection status for attendees (initial check)
        if (data.hasOwnProperty("host_connection_status") && !isHost()) {
          const isConnected = data.host_connection_status.value === "connected";
          dispatch(setHostConnectionStatus(isConnected));
        }
      });

      // Broadcast initial connection status when host joins (set as connected)
      if (isHost()) {
        addOrUpdateChannelAttributes("host_connection_status", "connected");
      }

      channel.on("ChannelMessage", async (message: any, peerId, memberId) => {
        if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == null
        ) {
          var userAttribute = await client?.getUserAttributes(peerId);
          appendMessage({
            text: JSON.parse(message.text).text,
            uid: userAttribute.uid,
            createAt: new Date().toLocaleTimeString([], { timeStyle: "short" }),
            type: "TEXT",
            firstName: JSON.parse(message.text).from.split(" ")[0],
            lastName: JSON.parse(message.text).from.split(" ")[1],
          });

          var obj = {
            "action": "chat.message",
            "data": {
              "streamInstanceId": stream_instance_id,
              "streamId": id,
              "message": JSON.parse(message.text).text,
              "created_at": new Date().toISOString(),
              "type": "message",
              "attendeeId": userAttribute.uid,
              "familyName": JSON.parse(message.text).from.split(' ')[1],
              "givenName": JSON.parse(message.text).from.split(' ')[0]
            }
          };
          if (ws != null && isHost()) {
            ws.send(JSON.stringify(obj));
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "interactions"
        ) {
          const messageData = JSON.parse(message.text);
          const interactionData = typeof messageData.interaction === 'string'
            ? JSON.parse(messageData.interaction)
            : messageData.interaction; // If it's already an object, no need to parse

          setInteractionDataArray(interactionData);
          var products_MA = interactionData.filter((item: any) => item.real_type === "shop_com");
          var products_PartnerCo = interactionData.filter((item: any) => item?.attributes?.siteName?.toLowerCase().trim() === "partner.co");

          if (products_MA.length > 0) {
            const isReloadProductRequire = !_.isEqual(products_MA, currentProduct);

            if (isReloadProductRequire) {
              currentProduct = products_MA;
              var hostData = localStorage.getItem("hostData");
              getItemDetailService(products_MA.map((item: any) => item.interaction_id).join(','), hostData!)?.then((res: any) => {
                dispatch(getProductDetails(res));
              }).catch((err: any) => {
                console.log(err);
              });
            }

          } else if (products_PartnerCo.length > 0) {
            currentProduct = products_PartnerCo;
            dispatch(setProductDetailsLoading(true));

            getItemDetailServiceForPartnerCo(products_PartnerCo.map((item: any) => item.interaction_id).join(','), products_PartnerCo[0]?.attributes?.locale, "morinda")?.then((res: any) => {
              dispatch(getProductDetails(res.data.map((item: any) => ({ ...item, locale: products_PartnerCo[0]?.attributes?.locale }))));
              dispatch(setProductDetailsLoading(false));
            }).catch((err: any) => {
              console.log(err);
              dispatch(setProductDetailsLoading(false));
            });
          } else {
            var products_Tranont = interactionData.filter((item: any) => item?.attributes?.siteName?.toLowerCase().trim() === "trannont");

            if (products_Tranont.length > 0) {
              currentProduct = products_Tranont;

              var hostData = localStorage.getItem("hostData");
              var isNfrProduct = products_Tranont.some((item: any) => !!item?.attributes?.nfr);

              // Set loading to true before API call
              dispatch(setProductDetailsLoading(true));

              getItemDetailServiceTranont(products_Tranont.map((item: any) => item.interaction_id).join(','), isNfrProduct, products_Tranont[0]?.attributes?.locale, "tranont")?.then((res: any) => {
                dispatch(getProductDetails(res.data.map((item: any) => ({ ...item, locale: products_Tranont[0]?.attributes?.locale, nfr: products_Tranont[0]?.attributes?.nfr }))));
                dispatch(setProductDetailsLoading(false));
              }).catch((err: any) => {
                console.log(err);
                dispatch(setProductDetailsLoading(false));
              });
            }
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "startedStreamingTime"
        ) {
          if (!isHost()) {
            dispatch(setHostTime(JSON.parse(message.text).text));
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "activity"
        ) {
          setActivityInteraction(JSON.parse(message.text));
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "HOST_TURNOFF_MIC"
        ) {
          if (JSON.parse(message.text).text == "true") {
            dispatch(turnOffHostMic());
            dispatch(toastMess(language['host_mic_muted']));
            setTimeout(() => {
              dispatch(toastMess(""));
            }, 5000);
          } else {
            dispatch(toastMess(language['host_mic_unmuted']));
            dispatch(turnOnHostMic());
            setTimeout(() => {
              dispatch(toastMess(""));
            }, 1500);
          }
        } else if (
          roleCopresenter &&
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "MUTE_COPRESENTER"
        ) {
          if (JSON.parse(message.text).text == uid.toString()) {
            dispatch(setMutedByHost(true));
            setTimeout(() => {
              dispatch(turnOffMic());
              dispatch(toastMess(language['host_mute_you']));
              setTimeout(() => {
                dispatch(toastMess(""));
              }, 3000);
            }, 100);
            setTimeout(() => {
              dispatch(setMutedByHost(false));
            }, 1000);
          }
        } else if (
          isHost() &&
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "configuration.copresenter-join"
        ) {
          dispatch(copresenterInfo({
            "firstName": JSON.parse(message.text).text.split("|")[0],
            "lastName": JSON.parse(message.text).text.split("|")[1],
          }));
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "HOST_TURNOFF_CAM"
        ) {
          // console.log(
          //   "interaction===>In Attendee==>HOST_TURNOFF_CAM",
          //   JSON.parse(message.text)
          // );
          if (JSON.parse(message.text).text == "true") {
            dispatch(turnOffHostCamera());
          } else {
            dispatch(turnOnHostCamera());
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "host_connection_status"
        ) {
          if (!isHost()) {
            const messageData = JSON.parse(message.text);
            const isConnected = messageData.connected === true;
            dispatch(setHostConnectionStatus(isConnected));
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "stream-end"
        ) {
          if (JSON.parse(message.text).text == "true") {
            if (isHost()) {
              navigate({ screen: screens.public.endLive });
              setTimeout(() => {
                window.location.reload();
              }, 100);
            } else {
              dispatch(setStramState("hostEnding"));
            }
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "historyMessage"
        ) {
          if (!isHost() && !hisotryMSG) {
            setMessages((JSON.parse(message.text).interaction));
            setHistoryMSG(true);
          }
        }
      });
      channel.on("MemberJoined", async (memberId: any) => {
        if (isHost()) {
          getJoinedUserDetails(memberId, true);
          setAttendeeNum((num) => num + 1);
        } else {
          try {
            let hostUserId = null;
            if (createStreamData?.metadata?.attendees?.length > 0) {
              hostUserId = createStreamData.metadata.attendees[0].stream_vendor_user_id;
            } else if (joinWithAttendeeData?.attendees?.length > 0) {
              hostUserId = joinWithAttendeeData.attendees[0].stream_vendor_user_id;
            }

            if (hostUserId && memberId.toString() === hostUserId.toString()) {
              dispatch(setHostConnectionStatus(true));
            }
          } catch (err) {
            // Silently handle errors
          }
        }
        setMemberJoin(memberId);
      });
      channel.on("MemberLeft", async (memberId: any) => {
        setMemberLeft(memberId);
        setAttendeeNum((num) => num - 1);

        if (!isHost()) {
          try {
            let hostUserId = null;
            if (createStreamData?.metadata?.attendees?.length > 0) {
              hostUserId = createStreamData.metadata.attendees[0].stream_vendor_user_id;
            } else if (joinWithAttendeeData?.attendees?.length > 0) {
              hostUserId = joinWithAttendeeData.attendees[0].stream_vendor_user_id;
            }

            if (hostUserId && memberId.toString() === hostUserId.toString()) {
              dispatch(setHostConnectionStatus(false));
            }
          } catch (err) {
            // Silently handle errors
          }
        }
      });

      channel.on("AttributesUpdated", (data: any) => {
        if (data.hasOwnProperty("SHOW_ATTENDEE")) {
          dispatch(
            showAttendeeCountFunc(
              data.SHOW_ATTENDEE.value == "true" ? true : false
            )
          );
        }

        if (data.hasOwnProperty("host_copresenter_uids")) {
          dispatch(
            setCopresenterUids(JSON.parse(data.host_copresenter_uids.value))
          );
        }
        
        if (data.hasOwnProperty("host_copresenter_info")) {
          dispatch(
            setCopresenterInfo(JSON.parse(data.host_copresenter_info.value))
          );
        }
        if (data.hasOwnProperty(PINNED_PRESENTER_UID_KEY)) {
          const parsedPinnedUid = parsePinnedLayoutUid(data[PINNED_PRESENTER_UID_KEY].value);
          dispatch(setPinnedLayoutUid(parsedPinnedUid));
          lastBroadcastPinnedLayoutUid.current = parsedPinnedUid;
          pinnedLayoutUidHydrated.current = true;
        }
        // Monitor host connection status updates for attendees (real-time via AttributesUpdated)
        if (data.hasOwnProperty("host_connection_status") && !isHost()) {
          const isConnected = data.host_connection_status.value === "connected";
          console.log('[AgoraChat] Attendee received host_connection_status via AttributesUpdated:', isConnected);
          dispatch(setHostConnectionStatus(isConnected));
        }
      });

      channel?.getMembers().then((data: any) => {
        dispatch(setPersonNum(data.length));
      });

      setChannel(channel);

      (window as any).agoraRTMChannel = channel;

      return channel;
    }
  };

  const sendMessage = (e: any) => {
    if (text === "") return;
    var firstName = publicUserData?.given_name;
    var lastName = publicUserData?.family_name;
    channel?.sendMessage({
      text: `{\"from\":\"${firstName} ${lastName}\",\"toId\":null,\"text\":\"${text}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":null,\"shouldFeatureInteraction\":false,\"interaction\":null}`,
      messageType: "TEXT",
    });
    appendMessage({
      text: text,
      uid: rtmTokenData.user_id,
      createAt: new Date().toLocaleTimeString([], { timeStyle: "short" }),
      type: "TEXT",
      firstName: firstName,
      lastName: lastName,
    });
    setText("");

    if (ws != null && isHost()) {
      var obj = {
        "action": "chat.message",
        "data": {
          "streamInstanceId": createStreamData.stream_instance_id,
          "streamId": id,
          "message": text,
          "created_at": new Date().toISOString(),
          "type": "message",
          "attendeeId": rtmTokenData.user_id,
          "familyName": publicUserData?.family_name,
          "givenName": publicUserData?.given_name,
        }
      };
      ws.send(JSON.stringify(obj));
    }
  };

  const sendInteractionMessages = (interactionData: any) => {
    if (interactionData == null) return;
    // channel?.sendMessage({ text, messageType: "INTERACTION" });
    channel?.sendMessage({
      text: `{\"from\":\"d z\",\"toId\":null,\"text\":\"${null}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${"interactions"}\",\"shouldFeatureInteraction\":false,\"interaction\":${interactionData}}`,
      messageType: "TEXT",
    });
  };

  const sendActivityInteractionMessages = (
    activityData: any,
    typeText: any,
    action: any
  ) => {
    let tempObje: any = activityData;
    if (JSON.parse(tempObje)?.firstName != undefined) {
      channel?.sendMessage({
        text: `{\"from\":${activityData},\"toId\":null,\"text\":\"${typeText}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${"activity"}\",\"shouldFeatureInteraction\":false,\"interaction\":null}`,
        messageType: "TEXT",
      });

      if (isHost() === true) {
        let dataTemp: any = `{\"from\":${activityData},\"toId\":null,\"text\":\"${typeText}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${"activity"}\",\"shouldFeatureInteraction\":false,\"interaction\":null}`;
        setActivityInteraction(JSON.parse(dataTemp));
      }
    }
  };

  const sendHostTime = (time: number) => {
    channel?.sendMessage({
      text: `{\"from\":\"d z\",\"toId\":null,\"text\":\"${String(
        time
      )}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${"startedStreamingTime"}\",\"shouldFeatureInteraction\":false,\"interaction\":null}`,
      messageType: "TEXT",
    });
  };

  const broadcastHostState = (status: boolean, actionType: String) => {
    channel?.sendMessage({
      text: `{\"from\":\"d z\",\"toId\":null,\"text\":\"${status ? "true" : "false"
        }\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${actionType}\",\"shouldFeatureInteraction\":false,\"interaction\":null}`,
      messageType: "TEXT",
    });
  };

  const broadcastMuteCopresenter = (uid: number, actionType: String) => {
    channel?.sendMessage({
      text: `{\"from\":\"d z\",\"toId\":null,\"text\":\"${uid
        }\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${actionType}\",\"shouldFeatureInteraction\":false,\"interaction\":null}`,
      messageType: "TEXT",
    });
  };

  const broadcastCopresenterInfo = (name: string, actionType: String) => {
    // console.log("[AGORA CHAT] Interaction data", interactionData);

    channel?.sendMessage({
      text: `{\"from\":\"d z\",\"toId\":null,\"text\":\"${name
        }\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${actionType}\",\"shouldFeatureInteraction\":false,\"interaction\":null}`,
      messageType: "TEXT",
    });
  };

  //************************CONNECT WEBSOCKET**********************************
  const connectWebSocket = () => {
    ws = new WebSocket(WS_URL);

    ws.onopen = () => {
      if (ws) {
        ws.send('{"action":"stream.created","data":{"streamId":"' + id + '"}}');
      }

      heartbeatInterval = setInterval(() => {
        if (ws && ws.readyState === WebSocket.OPEN) {
          ws.send('ping');
        }
      }, 20000);
    };

    ws.onmessage = (event) => {
      // console.log('get msg:', event.data);
    };

    ws.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    ws.onclose = () => {
      // console.log('WebSocket closed');
      if (heartbeatInterval) {
        clearInterval(heartbeatInterval);
      }
      setTimeout(() => {
        connectWebSocket();
      }, 5000);
    };
  }

  //************************FRIST JOIN CHANNEL**********************************
  useEffect(() => {
    if (uid == -1 || !channel) return;
    if (isHost() || roleCopresenter == true) {
      updateCopresenterUids((currentUids) => {
        const updatedUids = currentUids.includes(uid) ? currentUids : [...currentUids, uid];
        dispatch(setCopresenterUids(updatedUids));
        return updatedUids;
      }).catch((err) => {
        console.error('Error updating copresenter uids:', err);
      });

      const copresenterInfoData = {
        uid: uid,
        micOff: isHost() ? false : !isMicOn,
        videoOff: isHost() ? false : !isCameraOn,
        isScreenSharing: isScreenSharing,
        firstName: publicUserData?.family_name,
        lastName: publicUserData?.given_name,
        rotateDegree: rotateDegree,
      };

      updateCopresenterInfo((currentInfo) => {
        if (isHost()) {
          const existingIndex = currentInfo.findIndex((item: any) => item.uid === uid);
          if (existingIndex >= 0) {
            const updatedInfo = [...currentInfo];
            updatedInfo[existingIndex] = copresenterInfoData;
            dispatch(setCopresenterInfo(updatedInfo));
            return updatedInfo;
          } else {
            const updatedInfo = [copresenterInfoData];
            dispatch(setCopresenterInfo(updatedInfo));
            return updatedInfo;
          }
        } else {
          const existingIndex = currentInfo.findIndex((item: any) => item.uid === uid);
          if (existingIndex >= 0) {
            const updatedInfo = [...currentInfo];
            updatedInfo[existingIndex] = copresenterInfoData;
            dispatch(setCopresenterInfo(updatedInfo));
            return updatedInfo;
          } else {
            const updatedInfo = [...currentInfo, copresenterInfoData];
            dispatch(setCopresenterInfo(updatedInfo));
            return updatedInfo;
          }
        }
      }).catch((err) => {
        console.error('Error updating copresenter info on join:', err);
      });
      if (roleCopresenter) {
        // console.log("===========copresenter joined========", publicUserData);
        dispatch(copresenterInfo({
          "firstName": publicUserData?.given_name,
          "lastName": publicUserData?.family_name,
        }));
        broadcastCopresenterInfo(publicUserData.given_name + "|" + publicUserData.family_name, "configuration.copresenter-join");
      }
      if (isHost()) {
        connectWebSocket();
      }

    } else {
      client.getChannelAttributes(channel.channelId).then((data: any) => {
        if (data.hasOwnProperty("host_copresenter_uids")) {
          dispatch(
            setCopresenterUids(JSON.parse(data.host_copresenter_uids.value))
          );
        }

        if (data.hasOwnProperty("host_copresenter_info")) {
          var newVal = [...JSON.parse(data.host_copresenter_info.value)];
          dispatch(setCopresenterInfo(newVal));
        }
      });
    }
  }, [uid, channel]);

  //Update state with user data
  useEffect(() => {
    setUserConnect(publicUserData);
    //TODO: To be reviewed
  }, [publicUserData?.userId]);

  //HOST JOIN STREAM
  useEffect(() => {
    if (isHost() === true) {
      connect(rtmTokenData, createStreamData.stream_instance_id);

      return () => {
        const disconnect = async () => {
          // const channel = await connect(rtmTokenData, createStreamData.stream_instance_id);
          await channel?.leave();
          if (loged) {
            await client?.logout();
            setLoged(false);
          }
        };
        disconnect();
      };
    }
  }, [rtmTokenData, createStreamData]);

  //ATENDEE JOIN STREAM
  useEffect(() => {
    if (isHost() === false) {
      if (!isMobile) {
        connect(rtmTokenData, joinData.stream_instance_id);

        return () => {
          const disconnect = async () => {
            const channel = await connect(
              rtmTokenData,
              joinData.stream_instance_id
            );
            await channel?.leave();
            if (loged) {
              await client?.logout();
              setLoged(false);
            }
          };
          disconnect();
        };
      } else {
        if (!loged) {
          connect(rtmTokenData, joinData.stream_instance_id);
        }

        return () => {
          const disconnect = async () => {
            if (loged) {
              const channel = await connect(
                rtmTokenData,
                joinData.stream_instance_id
              );
              await channel?.leave();
            }
            if (loged) {
              // console.log("789");
              await client?.logout();
              setLoged(true);
            }
          };
          disconnect();
        };
      }
    }
  }, [rtmTokenData, joinData]);

  useEffect(() => {
    if (rtmTokenData.token) {
      setIsChatOn(true);
    }
  }, [rtmTokenData]);

  //************************NEW USERS JOINING**********************************
  useEffect(() => {
    if (isHost() === true) {
      sendHostTime(hostTime);
    }

    channel?.getMembers().then((data: any) => {
      dispatch(setPersonNum(data.length));
    });

    updateAttendeeList();
  }, [attendeeNum]);

  useEffect(() => {
    if (isHost() === true) {
      sendActivityInteractionMessages(
        JSON.stringify(joinedUser),
        `${joinedUser.firstName} ${joinedUser.lastName} has joined`,
        "user joined"
      );


      setTimeout(() => {
        sendInteractionMessages(JSON.stringify(interactionData));
      }, 1000);
    }
  }, [joinedUser]);

  useEffect(() => {
    if (isHost() === true) {
      sendActivityInteractionMessages(
        JSON.stringify(leftUser),
        `${leftUser.firstName} ${leftUser.lastName} has Left`,
        "user left"
      );
    }
    // console.log(leftUser);
  }, [leftUser]);

  useEffect(() => {
    // host left the stream
    window.addEventListener("unload", async function (event) {
      if (isHost()) {
        await dispatch(setStramState("ended"));
        event.preventDefault();
      }
    });
  });

  //************************INTERACTIONS**********************************
  useEffect(() => {
    if (isHost() === false) {
      dispatch(setInteractionData(interactionDataArray));
    }
  }, [interactionDataArray]);

  useEffect(() => {

    if (interactionData.length > 0) {
      if (isHost() === true) {
        isInteractionAdded.current = true;

        sendInteractionMessages(JSON.stringify(interactionData));
      }
    } else if (interactionData.length == 0) {
      if (isInteractionAdded.current) {
        isInteractionAdded.current = false;

        sendInteractionMessages(JSON.stringify(interactionData));
      }
    }
  }, [interactionData]);
  
  useEffect(() => {
    if (isHost() === false) {
      let objUserTemp: any = {
        firstName: publicUserData?.given_name,
        lastName: publicUserData?.family_name,
        avatar:
          publicUserData?.picture ??
          "https://s3-us-west-2.amazonaws.com/investo-bucket/default_avatar.png",
        id: publicUserData.userId ?? joinData.attendee_id,
        uid: rtmTokenData?.user_id,
        email: publicUserData?.email,
      };
      sendActivityInteractionMessages(
        JSON.stringify(objUserTemp),
        `${objUserTemp?.firstName} ${objUserTemp?.lastName} has clicked on ${selectedInteraction?.attributes?.label}`,
        "interaction clicked"
      );
    }
  }, [selectedInteraction]);

  //************************STREAM END**********************************
  useEffect(() => {
    if (isHost() && streamState === "ended") {
      if (isHost()) {
        // console.log("===========stream-end========");
        broadcastHostState(true, "stream-end");
        if (ws) {
          ws.close();
        }
      } else {
        channel?.leave();
        client?.logout();
      }
    }

    if (
      streamState === "ended" &&
      window.location.href.indexOf("/login") > -1
    ) {
      broadcastHostState(true, "stream-end");
    }
  }, [streamState]);

  const getJoinedUserDetails = async (userId: any, isJoined: any) => {
    var userAttribute = await client?.getUserAttributes(userId);
    if (isJoined) {
      setJoinedUser(userAttribute);
    } else {
      setLeftUser(userAttribute);
    }
  };

  const setActivityInteraction = (data: any) => {
    setJoinedUserArray((prevArray: any) => [...prevArray, data]);
  };

  useEffect(() => {
    dispatch(setActivityInteractionData(joinedUserArray));
  }, [joinedUserArray]);

  // Poll channel attributes for host connection status (attendee side - backup method)
  useEffect(() => {
    if (!isHost() && channel && loged) {
      const checkHostConnectionStatus = async () => {
        try {
          const attributes = await client.getChannelAttributes(channel.channelId);
          if (attributes.hasOwnProperty("host_connection_status")) {
            const isConnected = attributes.host_connection_status.value === "connected";
            dispatch(setHostConnectionStatus(isConnected));
          }
        } catch (err) {
          // Silently handle errors
        }
      };

      // Check immediately and then poll every 3 seconds as backup
      checkHostConnectionStatus();
      const connectionStatusInterval = setInterval(checkHostConnectionStatus, 3000);

      return () => {
        clearInterval(connectionStatusInterval);
      };
    }
  }, [channel, loged]);

  // Broadcast host connection status via RTM when it changes (host side only)
  useEffect(() => {
    if (isHost() && channel && typeof isHostConnected !== 'undefined') {
      const status = isHostConnected ? "connected" : "disconnected";
      // Update channel attributes
      addOrUpdateChannelAttributes("host_connection_status", status);
      // Also send RTM message for more reliable real-time updates
      channel?.sendMessage({
        text: JSON.stringify({
          actionType: "host_connection_status",
          connected: isHostConnected
        }),
        messageType: "TEXT",
      });
    }
  }, [isHostConnected, channel]);

  useEffect(() => {
    if (!channel || !channel.channelId) {
      return;
    }
    if (!(isHost() || roleCopresenter)) {
      return;
    }
    if (!isHost() && roleCopresenter && !pinnedLayoutUidHydrated.current) {
      return;
    }
    if (lastBroadcastPinnedLayoutUid.current === pinnedLayoutUid) {
      return;
    }

    const rawPinnedValue =
      pinnedLayoutUid === null || typeof pinnedLayoutUid === "undefined"
        ? "null"
        : String(pinnedLayoutUid);

    addOrUpdateChannelAttributes(PINNED_PRESENTER_UID_KEY, rawPinnedValue)
      .then(() => {
        lastBroadcastPinnedLayoutUid.current = pinnedLayoutUid;
      })
      .catch((err) => {
        console.error("Error updating pinned presenter uid:", err);
      });
  }, [pinnedLayoutUid, channel?.channelId, roleCopresenter]);

  const dynamicHeader = (activeTab: string) => {
    switch (activeTab) {
      case "chat":
        return "Chat";
      case "attendees":
        return "Attendees";
      case "activity":
        return "Activity";
      default:
        return "Chat";
    }
  };

  const onChangeActiveTab = (activeTab: string) => {
    setActiveTab(activeTab);
  };

  const onChangeText = (e: any) => {
    setText(e);
  };

  return (
    <>
      {!isMobile ? (
        <>
          <div className="w-full items-center justify-center bg-[#1F1F1F]">
            <HeaderChat
              activeTab={activeTab}
              onChangeActiveTab={onChangeActiveTab}
              dynamicHeader={dynamicHeader}
            />
          </div>
          <div>
            {activeTab === "chat" && (
              <MessageItem
                messages={messages}
                userConnect={userConnect}
                memberJoin={memberJoin}
                memberLeft={memberLeft}
              />
            )}
          </div>
          <>
            {activeTab === "chat" && (
              <div
                className="pl-1 pr-1"
                style={{
                  position: "absolute",
                  bottom: 55,
                  width:
                    document.getElementById("agoraChatContainer")?.offsetWidth,
                  height: 56,
                }}
              >
                <Chatbox
                  sendMessage={sendMessage}
                  onChangeText={onChangeText}
                  textValue={text}
                  isChatOn={isChatOn}
                />
              </div>
            )}
          </>
          {activeTab === "attendees" && <AttendeesChat />}
          {activeTab === "activity" && <ActivityChat />}
        </>
      ) : (
        <>
          <div className="w-full absolute left-0 right-0">
            <MessageItem messages={messages} />
          </div>
          <div className="absolute bottom-0 w-full left-0 right-0">
            <Chatbox
              sendMessage={sendMessage}
              onChangeText={onChangeText}
              textValue={text}
              isChatOn={isChatOn}
            />
          </div>
        </>
      )}
    </>
  );
};

export default AgoraChat;
